import Vue from 'vue';
import { appKey } from '../helpers/appStorage';

export default new Vue({
  data() {
    return {
      innerTenant: localStorage.getItem(appKey("tenant")),
    }
  },
  watch: {
    innerTenant(to) {
      if (to == null) {
        localStorage.removeItem(appKey("tenant"));
      } else {
        localStorage.setItem(appKey("tenant"), to);
      }
    },
  },
  computed: {
    tenant() {
      return this.innerTenant;
    },
  },
  created() {
  },
  methods: {
    setTenant(tenant) {
      this.innerTenant = tenant;
    },
    clear() {
      this.innerTenant = null;
    }
  },
})
